export default "__VITE_ASSET__C5KENjU6__";